export enum FeatureFlag {
  // global feature flags
  CONNECTED_AIR_SOLUTIONS_OVERVIEW = 'connected-air-solutions-overview',
  DASHBOARD_DDD = 'dashboard-ddd',
  DOSATRON_WIDGETS = 'dosatron-widgets',
  ENTRAID_LOGIN = 'entra_id_login',
  EP_FLEET_VIEW_WRITE_ENABLED = 'ep-fleet-view-write-enabled',
  EP_MODEL_REPO_SYNC = 'ep-model-repo-sync',
  EP_TREE_EVENTS_ENABLED = 'ep-tree-events-enabled',
  FARO = 'faro',
  FREESCOUT_KNOWLEDGEBASE = 'freescout-knowledgebase',
  HOTJAR = 'hotjar',
  MONITORING_NO_30_S_BUCKETS = 'drop-30s-buckets',
  PRICESPIDER = 'pricespider',
  TAG_BROWSER = 'tag-browser',
  UM2_LTREE = 'um2-ltree',
  USERMANAGEMENT_V2 = 'usermanagement-v2',
  USERSNAP = 'usersnap',

  // Customer portal feature flags
  CP_ENABLE_ASSET_MODEL_NUMBER_EDIT = 'cp_enable_asset_model_number_edit',
  CP_ENABLE_NEW_ASSET_TILE = 'cp_enable_new_asset_tile',
  CP_ENABLE_REGISTRATION = 'cp_enable_registration',
  CP_ENABLE_SERVICE_AND_MAINTENANCE = 'cp_enable_service',
  CP_ENABLE_NEW_ASSET_DETAIL = 'cp_enable_new_asset_detail',
  CP_ENABLE_SCHEDULE_SERVICE = 'cp_enable_schedule_service',
}
